import layout from '@/layout'

const meta = {
  auth: true
}

export default {
  path: '/',
  component: layout,
  children: [
    {
      path: 'dashboard',
      name: `Dashboard`,
      meta: { ...meta, cache: true, title: '数据看板', PID: 'T00' },
      component: () => import('@/views/digital/dashboard')
    }
  ]
}
